var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _c("changePassword", {
        ref: "changePassword",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.initDialogChangePasswordVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.initDialogChangePasswordVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("readWebOnlineTerms", {
        ref: "readWebOnlineTerms",
        attrs: {
          "destroy-on-close": true,
          width: "80%",
          "max-height": "80%",
          registerTermNo: _vm.registerTermNo,
          bookingTermNo: _vm.bookingTermNo,
          registerTermContent: _vm.registerTermContent,
          bookingTermContent: _vm.bookingTermContent,
          visible: _vm.initDialogReadWebOnlineTermsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.initDialogReadWebOnlineTermsVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }